module.exports = __webpack_public_path__ + "img/038-i love you.b21f67ea.svg";